import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCIcon, RCCButton, RCCAlert, RCCTooltip, RCCGrid } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import DropdownWithBackground from "../DropdownWithBackground";
import PageTitle from "../PageTitle";
import ISidebarCard, { IRefSidebarCard, ISidebarCardItem } from "./interface";
import { SidebarCardContainer, SideBar, ContentBar, Card } from "./styles";

const SidebarCard: React.ForwardRefRenderFunction<IRefSidebarCard, ISidebarCard> = ({
	title,
	icon,
	styleInline,
	options,
	cards,
	filterContent,
	buttonsContent,
	cardClick,
	content,
	customCards,
	defaultCardSelected,
	trashLink
}, ref) => {
	const { translate } = useTranslation();
	const [cardSelected, setCardSelected] = useState<number | undefined>(defaultCardSelected);
	const [listVisible, setListVisible] = useState(!defaultCardSelected);
	const localRef = useRef<IRefSidebarCard>(null);
	const sidebarCardRef = ref || localRef;
	
	const sidebarArrowFunction = () => {
		setListVisible(!listVisible);
	};

	const onClickCardFuncion = (id:number, titleCard: string, card: any) => {
		window.scrollTo(0, 0);
		setCardSelected(id);
		
		if(cardClick)
			cardClick(id, titleCard, card);
	};

	useImperativeHandle(sidebarCardRef, () => ({
		changeListVisibility: sidebarArrowFunction,
		onClickCardFuncion
	}));

	return (
		<>
			<RCCGrid container>
				{icon && title && (
					<PageTitle
						title={title}
						icon={icon}
						trashLink={trashLink}
					></PageTitle>
				)}
				<SidebarCardContainer styleInline={styleInline} >
					<SideBar listVisible={listVisible}>
						<div className="sidebar-arrow-container">
							<RCCTooltip
								text={ listVisible ? translate("Ocultar") : translate("Mostrar")}
								color="grey"
							>						
								<RCCIcon 
									className="sidebar-arrow" 
									name={listVisible ? "arrowLeft" : "arrowRight"} 
									size={36} 
									onClick={sidebarArrowFunction}>
								</RCCIcon>
							</RCCTooltip>
						</div>
						<div className="sidebar-head">
							<div className="sidebar-nav">
								{buttonsContent}
							</div>
							{/* Filters */}
							{filterContent}
						</div>
						<div className="sidebar-body">
							{listVisible && (
								<>
									{!cards ? customCards : (
										<>
											{cards.length === 0 ? (
												<RCCAlert
													description={translate("Não foram encontrados dados")}
												/>
											): (
												<>
													{cards.map((card: ISidebarCardItem) => 
														card.filtered &&
														<Card 
															key={card.id} 
															onClick={(e) => {
																e.stopPropagation(); 
																setListVisible(false); 
																onClickCardFuncion(card.id, card.title, card);
															}} 
															selected={cardSelected === card.id}
															active={card.active}
														>
															<div className="card-head">
																{
																	card.favorite !== undefined && card.favorite &&
																	<span className="icon-favorite">
																		<RCCIcon name="starFilled" size={15} color={card.selected ? "#FFF" : "var(--grey)"}/>
																	</span>
																}
																{
																	options && 
																	<span className="icon-options">
																		<DropdownWithBackground
																			position="left"
																			callerComponent={
																				<RCCButton
																					color="transparent"
																				>
																					<RCCIcon name="dotsVertical" size={18} color={card.selected ? "#FFF" : "var(--grey)"}/>
																				</RCCButton>
																			}
																			useStopPropagation
																		>
																			{options(card)}
																		</DropdownWithBackground>
																	</span>
																}
															</div>
															
															<div className="card-body"><span title={card.title}>{card.title}</span></div>
															<div className="card-footer"><span title={card.subtitle}>{card.subtitle}</span></div>
														</Card>
													)}
												</>
											)}
										</>
									)}
								</>
							)}	
						</div>
					</SideBar>
					<ContentBar listVisible={listVisible}>
						{content || 
							<span>
								<RCCAlert
									title={translate("Nenhum card selecionado")}
									description={translate("Selecione um card para ver seus detalhes")}
								/>
							</span>
						}
					</ContentBar>
				</SidebarCardContainer>
			</RCCGrid>
			
		</>
	);
};

export default forwardRef(SidebarCard);

